export default __webpack_public_path__ + "static/media/quatre.a95b9ad1.jpg";